module.exports = __webpack_public_path__ + "img/dp-big--portfolio-02.269c71f6.jpg";